module.exports = __webpack_public_path__ + "static/media/arrow-right.d05d16d7.svg";